import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import Button from 'screens/components/basic/Button';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SelectInput from 'screens/components/basic/SelectInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
import './styles.css';

const componentName = "HightideReports";
class Body extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }

    }

    render() {
        let props = this.props
        return (
            <div className="row m-0">
                <div className="title_summary">
                    <h5 className="m-0 text-center text-justify">&nbsp;</h5>
                </div>
                <div className="report-table-container">
                    <table className="report-table w-100">
                        <tbody>
                            <tr id="dropdown">
                                <td className="text-left"><h5>Detailed Product Sales</h5></td>
                                <td className="text-left">
                                    <DatePickerInput
                                        name={componentName + "DetailedProductSalesBeginDate"}
                                        floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                        hintText={LOOKUP.report.common.beginDate.label + "*"}
                                        fullWidth={true}
                                        required
                                    />
                                </td>
                                <td className="text-left">
                                    <DatePickerInput
                                        name={componentName + "DetailedProductSalesEndDate"}
                                        floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                        hintText={LOOKUP.report.common.endDate.label + "*"}
                                        fullWidth={true}
                                        required
                                    />
                                </td>
                                <td className="text-left">
                                    <SelectInput
                                        name={componentName + "DetailedProductSalesProvince"}
                                        fullWidth
                                        defaultValue="All"
                                        label="Province"
                                        floatingLabelText="Province"
                                        options={props.provinceOptions}
                                    />
                                </td>
                                <td className="text-left">
                                    <BranchMultiSelectAutoCompleteInput
                                        defaultValues={props.branchOptions}
                                        className="report-branch-select"
                                        name={componentName + "DetailedProductSalesBranches"}
                                        label="Branches"
                                        floatingLabelText="Branches"
                                        hintText="Select Branches to display"
                                        style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                                        provinceFilter={props.detailedProductSalesProvince}
                                    />
                                </td>
                                <td className="text-left">
                                    <SelectInput
                                        name={componentName + "DetailedProductSalesCategory"}
                                        defaultValue="0"
                                        fullWidth={true}
                                        label={"Category"}
                                        floatingLabelText={"Category"}
                                        hintText={"Category"}
                                        options={props.categoryOptions}
                                    />
                                </td>
                                <td className="text-left">
                                    <SelectInput
                                        name={componentName + "DetailedProductSalesOption"}
                                        fullWidth={true}
                                        defaultValue="0"
                                        label={"Options"}
                                        floatingLabelText={"Options"}
                                        options={[
                                            { text: "Default", value: "0" },
                                            { text: "Include Deposits, Rounding", value: "1" }
                                        ]}
                                    />
                                </td>
                                <td className="text-right">
                                    <Button
                                        type="DownloadButton"
                                        className="mt-2 btnNewBrandPOS"
                                        name={componentName + "downloadDetailedProductSales"}
                                        label={"Download"}
                                        onTouchTap={() => props.download("DetailedProductSales")}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="text-left"><h5>Weekly Sales Ordering Multistore</h5></td>
                                <td></td>
                                <td className="text-left">
                                    <DatePickerInput
                                        name={componentName + "WeeklySalesEndDate"}
                                        floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                        hintText={LOOKUP.report.common.endDate.label + "*"}
                                        fullWidth={true}
                                        required
                                    />
                                </td>
                                <td className="text-left">
                                    <SelectInput
                                        name={componentName + "WeeklySalesProvince"}
                                        fullWidth={true}
                                        defaultValue="All"
                                        label={"Province"}
                                        floatingLabelText="Province"
                                        options={props.provinceOptions}
                                    />
                                </td>
                                <td className="text-left">
                                    <BranchMultiSelectAutoCompleteInput
                                        defaultValues={props.branchOptions}
                                        className="report-branch-select"
                                        name={componentName + "WeeklySalesBranches"}
                                        label="Locations"
                                        floatingLabelText="Select Location(s)"
                                        hintText="Select locations to display"
                                        style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                                        provinceFilter={props.weeklySalesProvince}
                                    />
                                </td>
                                <td className="text-left">
                                    <SelectInput
                                        name={componentName + "WeeklySalesCategory"}
                                        defaultValue="0"
                                        fullWidth={true}
                                        label={"Category"}
                                        floatingLabelText={"Category"}
                                        hintText={"Category"}
                                        options={props.categoryOptions}
                                    />
                                </td>
                                <td></td>
                                <td className="text-right">
                                    <Button
                                        type="DownloadButton"
                                        className="mt-2 btnNewBrandPOS"
                                        name={componentName + "downloadWeeklySalesOrderingMultistore"}
                                        label={"Download"}
                                        onTouchTap={() => props.download("WeeklySalesOrderingMultistore")}
                                    />
                                </td>
                            </tr>
                            {
                                props.isHighTide &&
                                <tr>
                                    <td className="text-left"><h5>Elite Sales</h5></td>
                                    <td className="text-left">
                                        <DatePickerInput
                                            name={componentName + "EliteSalesBeginDate"}
                                            floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                            hintText={LOOKUP.report.common.beginDate.label + "*"}
                                            fullWidth={true}
                                            required
                                        />
                                    </td>
                                    <td className="text-left">
                                        <DatePickerInput
                                            name={componentName + "EliteSalesEndDate"}
                                            floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                            hintText={LOOKUP.report.common.endDate.label + "*"}
                                            fullWidth={true}
                                            required
                                        />
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-right">
                                        <Button
                                            type="DownloadButton"
                                            className="mt-2 btnNewBrandPOS"
                                            name={componentName + "downloadEliteSales"}
                                            label={"Download"}
                                            onTouchTap={() => props.download("EliteSales")}
                                        />
                                    </td>
                                </tr>
                            }
                            {
                                props.isHighTide &&
                                <tr>
                                    <td className="text-left"><h5>Elite Sales Person Rank</h5></td>
                                    <td className="text-left">
                                        <DatePickerInput
                                            name={componentName + "EliteSalesPersonRankBeginDate"}
                                            floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                            hintText={LOOKUP.report.common.beginDate.label + "*"}
                                            fullWidth={true}
                                            required
                                        />
                                    </td>
                                    <td className="text-left">
                                        <DatePickerInput
                                            name={componentName + "EliteSalesPersonRankEndDate"}
                                            floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                            hintText={LOOKUP.report.common.endDate.label + "*"}
                                            fullWidth={true}
                                            required
                                        />
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-right">
                                        <Button
                                            type="DownloadButton"
                                            className="mt-2 btnNewBrandPOS"
                                            name={componentName + "downloadEliteSalesPersonRank"}
                                            label={"Download"}
                                            onTouchTap={() => props.download("EliteSalesPersonRank")}
                                        />
                                    </td>
                                </tr>
                            }
                            {
                                props.isHighTide &&
                                <tr>
                                    <td className="text-left"><h5>Global On Sale</h5></td>
                                    <td className="text-left">
                                        <DatePickerInput
                                            name={componentName + "GlobalOnSaleBeginDate"}
                                            floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                            hintText={LOOKUP.report.common.beginDate.label + "*"}
                                            fullWidth={true}
                                            required
                                        />
                                    </td>
                                    <td className="text-left">
                                        <DatePickerInput
                                            name={componentName + "GlobalOnSaleEndDate"}
                                            floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                            hintText={LOOKUP.report.common.endDate.label + "*"}
                                            fullWidth={true}
                                            required
                                        />
                                    </td>
                                    <td className="text-left">
                                        <SelectInput
                                            name={componentName + "GlobalOnSaleProvince"}
                                            fullWidth={true}
                                            defaultValue="All"
                                            label={"Province"}
                                            floatingLabelText="Province"
                                            options={props.provinceOptions}
                                        />
                                    </td>
                                    <td className="text-left">
                                        <BranchMultiSelectAutoCompleteInput
                                            defaultValues={props.branchOptions}
                                            className="report-branch-select"
                                            name={componentName + "GlobalOnSaleBranches"}
                                            label="Locations"
                                            floatingLabelText="Select Location(s)"
                                            hintText="Select locations to display"
                                            style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                                            provinceFilter={props.globalOnSaleProvince}
                                        />
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-right">
                                        <Button
                                            type="DownloadButton"
                                            className="mt-2 btnNewBrandPOS"
                                            name={componentName + "downloadGlobalOnSale"}
                                            label={"Download"}
                                            onTouchTap={() => props.download("GlobalOnSale")}
                                        />
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <div className="title_summary">
                    <h3 className="m-0 text-center text-justify">&nbsp;</h3>
                </div>
                <div className="report-table-container">
                    <table className="report-table w-100">
                        {
                            props.isHighTide &&
                            <tbody>
                                <td><h5 className="pull-left">Sage Export</h5></td>
                                <td className="text-right">
                                    <DatePickerInput
                                        name={componentName + "SageExportBeginDate"}
                                        floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                        hintText={LOOKUP.report.common.beginDate.label + "*"}
                                        fullWidth={true}
                                        required
                                    />
                                </td>
                                <td className="text-right">
                                    <DatePickerInput
                                        name={componentName + "SageExportEndDate"}
                                        floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                        hintText={LOOKUP.report.common.endDate.label + "*"}
                                        fullWidth={true}
                                        required
                                    />
                                </td>
                                <td className="text-left">
                                    <SelectInput
                                        name={componentName + "SageExportReportType"}
                                        defaultValue="All"
                                        fullWidth={true}
                                        label={"ReportType"}
                                        floatingLabelText={"ReportType"}
                                        hintText={"ReportType"}
                                        options={[
                                            { text: "All", value: "All" },
                                            { text: "Sales & AR", value: "salesAR" },
                                            { text: "COGS & Inventory", value: "cogsinventory" }
                                        ]}
                                    />
                                </td>
                                <td className="text-left">
                                    <SelectInput
                                        name={componentName + "SageExportVersion"}
                                        defaultValue="v2.0"
                                        fullWidth={true}
                                        label={"Version"}
                                        floatingLabelText={"Version"}
                                        hintText={"Version"}
                                        options={[
                                            {text: "v2.0", value: "v2.0"}, 
                                            {text: "v1.0", value: "v1.0"}
                                        ]}
                                    />
                                </td>
                                <td></td>
                                <td className="text-right">
                                    <Button
                                        type="DownloadButton"
                                        className="mt-2 btnNewBrandPOS"
                                        name={componentName + "downloadSageX3Export"}
                                        label={"Download"}
                                        onTouchTap={() => props.download("SageX3Export")}
                                    />
                                </td>
                            </tbody>
                        }
                        <tbody>
                            <td><h5 className="pull-left">Location List</h5></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-right">
                                <Button
                                    type="DownloadButton"
                                    className="mt-2 btnNewBrandPOS"
                                    name={componentName + "LocationList"}
                                    label={"Download"}
                                    onTouchTap={() => props.download("FinanceLocationList")}
                                />
                            </td>
                        </tbody>
                        <tbody>
                            <td><h5 className="pull-left">Payment Report Log</h5></td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "PaymentReportLogBeginDate"}
                                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "PaymentReportLogEndDate"}
                                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                    hintText={LOOKUP.report.common.endDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td className="text-left">
                                <SelectInput
                                    name={componentName + "PaymentReportLogProvince"}
                                    fullWidth
                                    defaultValue="All"
                                    label="Province"
                                    floatingLabelText="Province"
                                    options={props.provinceOptions}
                                />
                            </td>
                            <td className="text-left">
                                <BranchMultiSelectAutoCompleteInput
                                    defaultValues={props.branchOptions}
                                    className="report-branch-select"
                                    name={componentName + "PaymentReportLogBranches"}
                                    label="Branches"
                                    floatingLabelText="Branches"
                                    hintText="Select Branches to display"
                                    fieldName={'Branches'}
                                    provinceFilter={props.paymentReportLogProvince}
                                />
                            </td>
                            <td></td>
                            <td className="text-right">
                                <Button
                                    type="DownloadButton"
                                    className="mt-2 btnNewBrandPOS"
                                    name={componentName + "PaymentReportLog"}
                                    label={"Download"}
                                    onTouchTap={() => props.download("FinancePaymentReportLog")}
                                />
                            </td>
                        </tbody>
                        <tbody>
                            <td><h5 className="pull-left">Sales Log</h5></td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "SalesLogBeginDate"}
                                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "SalesLogEndDate"}
                                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                    hintText={LOOKUP.report.common.endDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td className="text-left">
                                <SelectInput
                                    name={componentName + "SalesLogProvince"}
                                    fullWidth
                                    defaultValue="All"
                                    label="Province"
                                    floatingLabelText="Province"
                                    options={props.provinceOptions}
                                />
                            </td>
                            <td className="text-left">
                                <BranchMultiSelectAutoCompleteInput
                                    defaultValues={props.branchOptions}
                                    className="report-branch-select"
                                    name={componentName + "SalesLogBranches"}
                                    label="Branches"
                                    floatingLabelText="Branches"
                                    hintText="Select Branches to display"
                                    style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                                    fieldName={'Branches'}
                                    provinceFilter={props.salesLogProvince}
                                />
                            </td>
                            <td></td>
                            <td className="text-right">
                                <Button
                                    type="DownloadButton"
                                    className="mt-2 btnNewBrandPOS"
                                    name={componentName + "SalesLog"}
                                    label={"Download"}
                                    onTouchTap={() => props.download("FinanceSalesLog")}
                                />
                            </td>
                        </tbody>
                        {
                            props.isHighTide &&
                            <tbody>
                                <td><h5 className="pull-left">Revenue Snapshot (SK Warehouse)</h5></td>
                                <td className="text-right">
                                    <DatePickerInput
                                        name={componentName + "RevenueSnapshotBeginDate"}
                                        floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                        hintText={LOOKUP.report.common.beginDate.label + "*"}
                                        fullWidth={true}
                                        required
                                    />
                                </td>
                                <td className="text-right">
                                    <DatePickerInput
                                        name={componentName + "RevenueSnapshotEndDate"}
                                        floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                        hintText={LOOKUP.report.common.endDate.label + "*"}
                                        fullWidth={true}
                                        required
                                    />
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="text-right">
                                    <Button
                                        type="DownloadButton"
                                        className="mt-2 btnNewBrandPOS"
                                        name={componentName + "RevenueSnapshot"}
                                        label={"Download"}
                                        onTouchTap={() => props.download("FinanceRevenueSnapshot")}
                                    />
                                </td>
                            </tbody>
                        }
                        <tbody>
                            <td><h5 className="pull-left">Operations Report</h5></td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "OperationsReportBeginDate"}
                                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "OperationsReportSalesEndDate"}
                                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                    hintText={LOOKUP.report.common.endDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-right">
                                <Button
                                    type="DownloadButton"
                                    className="mt-2 btnNewBrandPOS"
                                    name={componentName + "OperationsReport"}
                                    label={"Download"}
                                    onTouchTap={() => props.download("FinanceOperationsReport")}
                                />
                            </td>
                        </tbody>
                        <tbody>
                            <td><h5 className="pull-left">Safe Balances</h5></td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "SafeBalancesBeginDate"}
                                    floatingLabelText={LOOKUP.report.common.beginDate.label + "*"}
                                    hintText={LOOKUP.report.common.beginDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "SafeBalancesEndDate"}
                                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                    hintText={LOOKUP.report.common.endDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="text-right">
                                <Button
                                    type="DownloadButton"
                                    className="mt-2 btnNewBrandPOS"
                                    name={componentName + "SafeBalances"}
                                    label={"Download"}
                                    onTouchTap={() => props.download("FinanceSafeBalances")}
                                />
                            </td>
                        </tbody>
                        <tbody>
                            <td><h5 className="pull-left">Inventory Valuation</h5></td>
                            <td></td>
                            <td className="text-right">
                                <DatePickerInput
                                    name={componentName + "InventoryAtDateEndDate"}
                                    floatingLabelText={LOOKUP.report.common.endDate.label + "*"}
                                    hintText={LOOKUP.report.common.endDate.label + "*"}
                                    fullWidth={true}
                                    required
                                />
                            </td>
                            <td className="text-left">
                                <SelectInput
                                    name={componentName + "InventoryAtDateProvince"}
                                    fullWidth
                                    defaultValue="All"
                                    label="Province"
                                    floatingLabelText="Province"
                                    options={props.provinceOptions}
                                />
                            </td>
                            <td className="text-left">
                                <BranchMultiSelectAutoCompleteInput
                                    defaultValues={props.branchOptions}
                                    className="report-branch-select"
                                    name={componentName + "InventoryAtDateBranches"}
                                    label="Branches"
                                    floatingLabelText="Branches"
                                    hintText="Select Branches to display"
                                    fieldName={'Branches'}
                                    provinceFilter={props.inventoryAtDateProvince}
                                />
                            </td>
                            <td></td>
                            <td className="text-right">
                                <Button
                                    type="DownloadButton"
                                    className="mt-2 btnNewBrandPOS"
                                    name={componentName + "InventoryAtDate"}
                                    label={"Download"}
                                    onTouchTap={() => props.download("InventoryAtDate")}
                                />
                            </td>
                        </tbody>
                    </table >
                </div >
            </div >
        )
    }
};

const mapStateToProps = state => {
    return {
        detailedProductSalesProvince: state.form.HightideReportsDetailedProductSalesProvince,
        weeklySalesProvince: state.form.HightideReportsWeeklySalesProvince,
        globalOnSaleProvince: state.form.HightideReportsGlobalOnSaleProvince,
        paymentReportLogProvince: state.form.HightideReportsPaymentReportLogProvince,
        salesLogProvince: state.form.HightideReportsSalesLogProvince,
        inventoryAtDateProvince: state.form.HightideReportsInventoryAtDateProvince
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Body);


